import React, { useState } from "react";

import "./NewMonetarySanctionList.scss";
import ActionDropdown from "../ActionDropdown";
import DeleteModal from "../DeleteModal";
import { Button, Card } from "react-blueprint-library";

const NewMonetarySanctionList = ({
  list,
  setNewChargesList,
  setEditChargeDetailsList,
  setShowAddNewChargeModal,
}) => {
  const [show, setShow] = useState(false);
  const [actionIndex, setActionIndex] = useState(null);

  const handleDeleteAction = (index) => {
    if (index === null) {
      return;
    }

    const newList = list.filter((_, i) => i !== index);

    setNewChargesList(newList);
    setShow(false);
  };

  const handleEditAction = (index) => {
    if (index === null) {
      return;
    }

    setEditChargeDetailsList({
      list: list.find((_, i) => i === index),
      index,
    });

    setShowAddNewChargeModal(true);
  };

  return (
    <div className="new-mon-sanct-list">
      <hr className="hr-top" />
      <div className="list-header">
        <div className="left">
          <div id="monetarySancTypeTableId">Sanction Type</div>
          <div id="monetaryTotalAmountTableId">Total Amount</div>
        </div>
        <div id="monetaryActionTableId" className="action">
          Action
        </div>
      </div>

      <hr />

      <div className="rows">
        {list.map(({ totalAmount, sanctionType }, index) => (
          <>
            <div className="card-wrapper">
              <Card>
                <Card.Body>
                  <p>
                    <strong>Sanction Type: </strong>
                    {sanctionType}
                  </p>
                  <p>
                    <strong>Total Amount: $</strong>
                    {totalAmount}
                  </p>

                  <Card.Footer>
                    <div className="row">
                      <div className="col-6">
                        <Button
                          variant="tertiary"
                          onClick={() => {
                            handleEditAction(index);
                          }}
                        >
                          <span className="icon-edit"></span>
                          Edit
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button
                          variant="tertiary"
                          onClick={() => {
                            setActionIndex(index);
                            setShow(true);
                          }}
                        >
                          <span className="icon-delete"></span>
                          Delete
                        </Button>
                      </div>
                    </div>
                  </Card.Footer>
                </Card.Body>
              </Card>
            </div>
            <div key={`${index}-${sanctionType}`} className="rows-wrapper">
              <div className="drp-list-row">
                <div className="left">
                  <div id={`monetarySancType-${index}`}>{sanctionType}</div>
                  <div id={`monetaryTotalAmount-${index}`}>${totalAmount}</div>
                </div>

                <div className="action">
                  <ActionDropdown
                    id={`monetaryAction-${index}`}
                    key={index}
                    editAction={() => {
                      handleEditAction(index);
                    }}
                    showDelete={show}
                    deleteAction={() => {
                      setActionIndex(index);
                      setShow(true);
                    }}
                  />
                </div>
              </div>

              <div>
                <hr />
              </div>
            </div>
          </>
        ))}
      </div>

      <DeleteModal
        isOpen={show}
        showSpinner={false}
        closeClick={() => setShow(false)}
        deleteClick={() => handleDeleteAction(actionIndex)}
      />
    </div>
  );
};

export default NewMonetarySanctionList;
